// eslint-disable-next-line no-unused-vars
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileGet,
  // deleteRequest
  // postDataParams
} from '@/api/request'; // 导入request中创建的axios实例

//底图相关接口
const Mapapi = {
  //获取地图配置
  getconfig: (params, data) => {
    // return getRequest('saas/appSite/{appId}/gisView', params, data)
    return getRequest('base/geo/appView/' + params.appId, data)
  },
  getDict: (params, data) => {
    return getRequest('pub/dict/list', params, data)
  },
  //获取近期任务
  getRecentlyTask: (params, data) => {
    return getRequest('app/lztTask/recentTaskList', params, data)
  },
  //获取未完成的护林
  getUnfinishedProtect: (params, data) => {
    return getRequest('app/protect/patrol/underway', params, data)
  },
  //开始巡林
  protectStart: (params, data) => {
    return postRequest('app/protect/patrol/start', params, data)
  },
  //结束巡林
  protectStop: id => {
    return getRequest('app/protect/patrol/finish/' + id, {})
  },
  //签到
  protectSign: (params, data) => {
    return postRequest('/app/protect/sign', params, data)
  },
  //巡林-判断定位是否在林长负责的责任区内-肖东
  isInGrid: (point, parms) => {
    return getRequest('app/protect/isInGrid/' + point, parms)
  },
};

//个人接口
const User = {
  //获取当前登陆人信息
  loginInfo: (params) => {
    return getRequest('app/lzUser/getUserInfoByToken', params)
  },
  //获取用户信息
  userInfo: (params) => {
    return getRequest('app/lzUser/userInfo', params)
  },
  //获取政区列表
  areaList: params => { //成效统计数据展示接口-肖东
    return getRequest('base/geo/geoTree', params)
  },
  //获取下级政区列表
  getChildrenRegionList: params => { //获取下级政区-肖东
    return getRequest('base/geo/getChildrenRegionList', params)
  },
  myGridStatistics: params => { //责任区详情接口-陈国贵
    return getRequest('app/lzUserArea/myGridStatistics', params)
  },
  //获取人员数据权限配置-陈国贵
  userDataPermission: (uid) => {
    return getRequest("pub/userDataPermission/" + uid, {});
  },
};


//获取评论及点赞功能接口
const Review = {
  //获取文章评论
  DiscussDetail: (params) => {
    return getRequest('app/infoComment/commentList', params)
  },
  //获取文章评论点赞
  DiscussGood: (params) => {
    return postRequest('app/infoLikes/save', params)
  },
  //获取文章评论取消点赞
  DiscussBad: id => {
    return postRequest('app/infoLikes/delete/' + id, {})
  },

};

//新闻
const News = {
  //我的获取新闻详情
  myEssayDetail: params => {
    return getRequest('content/article/appArticleDetailByMyContent', params)
  },
  //获取文章详情
  newsDetail: (params) => {
    return getRequest('app/infoNews/appNewsDetails', params)
  },
  //获取百科新闻详情
  baikeNewsDetail: id => {
    return getRequest('app/infoNews/baikeNewsDetai/' + id, {})
  },
  //新闻阅读记录
  newsReadRecord: params => {
    return postRequestParams('app/infoNews/readRecord', params)
  },
  //改革示范区详情
  reformareaDetail: id => {
    return getRequest('app/demonstrationArea/details/' + id, {})
  },
};
//法律法规
const Laws = {
  //获取法律法规详情
  Detail: id => {
    return getRequest('app/infoLegal/baikeLegalDetai/' + id, {})
  },
  //新的-法律法规详情-陈国贵
  lawsDetail: id => {
    return getRequest('app/infoLegal/details/' + id, {})
  },
  //无token获取法律法规详情
  noneTokenDetail: id => {
    return getRequest('pub/register/baikeLegalDetai/' + id, {})
  },
  //法律法规阅读量计数接口-肖东
  addEffect: id => {
    return postRequest('app/infoLegal/addEffect/' + id, {})
  },
  saveCollect: params => { //法律新增收藏
    return postRequest('app/infoCollect/saveCollect', params)
  },
  cancelCollect: id => { //法律取消收藏
    return postRequest('app/infoCollect/cancelCollect/' + id, {})
  },
};
//通知
const inform = { //获取通知详情
  informMsg: params => {
    return getRequest('app/notice/getNoticeInfo', params)
  },
  getReadUserList: params => { //通知已查看人员列表查询接口-肖东
    return getRequest('app/notice/getReadUserList', params)
  },
  readCountAdd: params => { //通知已查看人员列表查询接口-肖东
    return postRequest('app/notice/readCountAdd', params)
  },
  kpiAdd: params => { //参与接口-谢明
    return postRequest('app/lzKpiParticipants/add', params)
  },
  kpiDeleted: params => { //退出接口-谢明
    return postRequestParams('app/lzKpiParticipants/deleted', params)
  },
  // addInform
  saveInform: (mode, params) => {
    //轮播图新增/编辑接口
    return mode == 'add' ?
      postRequest('app/notice/saveNotice', params) :
      postRequest('app/notice/updateNotice', params)
  },
};
//工作单
const worker = {
  indexMyGridSelect: (uid) => {
    //我的政区、责任区列表-陈国贵
    return getRequest("cms/index/myGeoList/" + uid, {});
  },
  regionAndGridTree: (params) => {
    return getRequest('cms/grid/getRegionAndGridTree', params)
  },
  sendUserList: params => { //派发人员列表查询接口-谢明
    return getRequest('app/workOrder/sendUserList', params)
  },
  getRegionAndGridTree: (params) => {//获取该责任区下的政区及责任区树结构接口-肖东
    return getRequest('app/workOrder/getRegionAndGridTree', params)
  },
  sendAllUserList: (params) => { //派发人员列表查询接口-王愿
    return getRequest('app/workOrder/getAppUserList', params)
  },
  newSendUserList: (pageSize, pageNum, uid, realName) => { //派发人员列表查询接口-王愿
    return getRequest('app/workOrder/sendUserList' +
      "?pageSize=" +
      pageSize +
      "&pageNum=" +
      pageNum +
      "&uid=" +
      uid +
      "&realName=" +
      realName, {})
  },
  saveWorkOrder: params => { //工作单保存接口-谢明
    return postRequest('app/workOrder/saveWorkOrder', params)
  },
  saveWorkOrderLog: params => { //工作单动态记录保存接口-谢明
    return postRequest('app/workOrder/saveWorkOrderLog', params)
  },
  workOrderDetails: id => { //工作单详情查询接口-谢明
    return getRequest('app/workOrder/workOrderDetails/' + id, {})
  },
  cancelWorkOrder: id => { //工作单撤销接口-谢明
    return postRequest('app/workOrder/cancelWorkOrder/' + id, {})
  },
  workOrderLogList: params => { //工作单动态记录列表查询接口-谢明
    return getRequest('app/workOrder/workOrderLogList', params)
  },
}
//护林单
const hulin = {
  sendUserList: (pageNum, pageSize, params) => { //护林单人员列表查询接口-肖东
    return getRequest('app/lzUser/getHLUserList/' + pageNum + '/' + pageSize, params)
  },
  currentInfo: params => { //当前位置信息汇总-刘韦
    return postRequest('base/perception/currentInfo', params)
  },
  addAndUpdate: params => { //护林单新增或编辑接口-肖东
    return postRequest('app/lzProtectForestNote/addAndUpdate', params)
  },
  hylDetails: id => { //护林单详情接口-肖东
    return getRequest('app/lzProtectForestNote/details/' + id, {})
  },

}

//扫一扫 参与多人考核
const Scan = {
  //获取法律法规详情
  scanDetail: id => {
    return getRequest('app/lzKpiForm/details/' + id, {})
  },
};
//通用模块接口
const universal = {
  linLongMsg: id => { //获取林长基本信息
    return getRequest('app/lzUser/userInfoByObjid/' + id, {})
  },
  //林地信息
  forest: {
    forestMsg: id => { //获取林地基本信息
      return getRequest('app/geoXiaoban/details/' + id, {})
    },
    forestEvaluateList: params => { //林地评价列表查询接口-肖东
      return getRequest('app/geoXiaoban/getAreaEvaluateList', params)
    },
    addAreaEvaluate: params => { //林地评价新增取消接口-肖东
      return postRequest('app/geoXiaoban/addAreaEvaluate', params)
    },
    ReplenishEvaluate: params => { //林地评价补充接口-肖东
      return postRequest('app/geoXiaoban/ReplenishEvaluate', params)
    },
    getAreaCommentList: params => { //林地评论列表查询接口-肖东
      return getRequest('app/geoXiaoban/getAreaCommentList', params)
    },
    getAreaBoard: params => { //林地电子公示牌查询接口-肖东
      return getRequest('app/geoXiaoban/getAreaBoard', params)
    },
  },
  //政区接口
  zqArea: {
    regionDetail: params => { //政区信息查询接口-肖东
      return getRequest('app/lzUserRegion/regionDetail', params)
    },

    lzUserRegionDetails: params => { //资源信息-政区责任区信息查询接口-肖东
      return getRequest('app/lzUserRegion/lzUserRegionDetails', params)
    },

  },
  //责任区接口
  dutyArea: {
    getDutyAreaList: id => { //获取林长下的责任区
      return getRequest('app/lzUser/lzGridAndRegionList/' + id, {})
    },

    dutyMsg: params => { //责任区信息查询接口-肖东
      return getRequest('app/lzUserArea/lzUserAreaDetails', params)
    },
    getAreaBoard: (mode, zqCode, params) => { //林地电子公示牌查询接口-肖东
      return mode == 'zq' ?
        getRequest('app/lzUserRegion/getAreaBoard/' + zqCode, {}) : //政区电子公示牌查询接口-肖东
        getRequest('app/lzUserArea/getAreaBoard', params) //责任区电子公示牌查询接口-肖东

    },
    nextRegionList: params => { //责任区下级政区查询接口-肖东
      return getRequest('app/lzUserArea/nextRegionList', params)
    },
    gridStatistics: params => { //责任区-一林一档查询接口-肖东
      return getRequest('app/lzUserArea/gridStatistics', params)
    },
    getUserArea: params => { //获取林长责任区接口-肖东
      return getRequest('app/lzUser/getUserArea', params)
    },
    getYlycInfo: params => { //一林一策详情接口-陈国贵
      return getRequest('app/lzUserArea/getYlycInfo', params)
    },
    gridStatisticalChart: params => { //一林一档林地、湿地统计接口-陈国贵
      return getRequest('app/lzUserArea/gridStatisticalChart', params)
    },
    // 新接口
    zqDutyMsg: params => { //通用-政区详情信息接口-谢明
      return getRequest('app/lzUserRegion/regionDetail', params)
    },
    zrqDutyMsg: params => { //责任区信息查询接口-肖东
      return getRequest('app/lzUserArea/lzUserAreaDetails', params)
    },

    zqNextGridList: (pageNum, pageSize, params) => { //政区的下级责任区信息接口-肖东
      return getRequest('app/lzUserRegion/nextGridList/' + pageNum + '/' + pageSize, params)
    },
    getGridArchives: params => { //根据责任区|政区获取文本信息接口-陈国贵
      return getRequest('app/lzUserArea/gridArchives', params)
    },
    getPlayauth: (videoId) => {
      //获取音视频播放凭证信息
      return fileGet("base/oss/vod/playauth/" + videoId, {});
    },
  },
  //古树信息
  oldTree: {

    oldTreeMsg: id => { //古树基本信息查询接口-陶创
      return getRequest('app/ancientTreeInfo/ancientTreeDetails/' + id, {})
    },
    geoGuShuMsg: params => { //古树所属林地信息查询接口-谢明
      return getRequest('app/ancientTree/linDiDetail', params)
    },
    GuShuPhotosDetail: params => { //古树照片信息查询接口-陶创
      return getRequest('app/ancientTree/guShuPhotosDetail', params)
    },

    // GuShuCommentDetail: params => { //古树评论信息查询接口-陶创
    //   return getRequest('app/geoGuShu/guShuCommentDetail', params ,'oldTree')
    // },
    // addGuShuPhotos: params => { //古树照片新增接口-谢明
    //   return postRequest('app/geoGuShu/addGuShuPhotos', params)
    // },
    // delGuShuPhotos: id => { //古树照片删除接口-谢明
    //   return postRequest('app/geoGuShu/delGuShuPhotos/' + id, {})
    // },
    //古树数据监控曲线
    getChart: (device, key) => { //古树照片删除接口-谢明
      return postRequest('pub/collection/chart/' + device + '/' + key, {})
    },
  },
  //任务信息
  taskMsg: id => { //获取任务详情信息 
    return getRequest('app/lztTask/details/' + id, {})
  },
  //发现信息
  findMsg: params => { //获取发现信息
    return getRequest('app/sysDiscover/discoverDetail', params)
  },
  //湿地信息
  wetlandMsg: id => { //获取湿地信息接口-肖东
    return getRequest('app/geoShidi/details/' + id, {})
  },
  //政区信息
  regionDetail: params => { //获取政区信息接口-谢明
    return getRequest('app/lzUserRegion/regionDetail', params)
  },
  //公示牌信息
  geoBoard: params => { //公示牌详情查询接口-肖东
    return getRequest('app/geoBoard/details', params)
  },
  //监测点信息
  geoMonitor: params => { //监测点详情查询接口-肖东
    return getRequest('app/geoMonitor/details', params)
  },
  monitordeviceMsg: (params) => { //监测点视频-张涛山
    return postRequest('iot/device/deviceMsg', params)
  },
  getVideoUrl: (device, isHTTPS, params) => { //生态检测获取视频地址接口-张涛山
    return postRequestParams('cms/monitor/getVideoSurveillance/' + device + '/' + isHTTPS, params)
  },
  //自然保护地信息
  geoBaohudi: params => { //保护地详情查询接口-肖东
    return getRequest('app/geoBaohudi/details', params)
  },
  //生态红线信息
  geoHongxian: params => { //生态红线详情查询接口-肖东
    return getRequest('app/geoHongxian/details', params)
  },
  //添加 古树、林地评论
  addCommont: (mode, params) => { //添加评论 -刘韦
    if (mode == 'forest') {
      return postRequest('app/geoXiaoban/sendAreaComment', params)
    } else {
      return postRequest('app/geoGuShu/sendGushuComment', params)
    }

  },
  //界桩详情接口
  boundary: {
    boundaryDetaisl: (id) => {
      return getRequest('cms/boundarypillar/getDetailsById/' + id, {})
    },
  },
  //营造林详情接口
  yzld: {
    yzldDetaisl: (objid) => {
      return getRequest('app/geoZaolin/zaolinDetailsByObjid/' + objid, {})
    },

  }
};
//林长模块
const linLong = {
  //数据模块
  record: {
    getGroupEffect: params => { //林长-组织成效查询接口-肖东
      return getRequest('app/lzEffectLog/getGroupEffect', params)
    },

    LzEffectRankingList: params => { //林长数据-个人成效-成效排名列表接口-肖东
      return getRequest('app/lzEffectLog/LzEffectRankingList', params)
    },
    getGroupKpi: params => { //林长-组织考核接口-肖东
      return getRequest('app/lzKpiForm/getGroupKpi', params)
    },
    getKpiRankingList: params => { //林长--考核名次排名接口-肖东
      return getRequest('app/lzKpiForm/lzKpiRankingList', params)
    },
  },
  //详情模块
  detail: {
    effectStatistices: params => { //成效统计数据展示接口-肖东
      return getRequest('app/lzEffectLog/effectStatistices', params)
    },
    getList: params => { //成效记录列表接口-肖东
      return getRequest('app/lzEffectLog/list', params)
    },
    myKpiList: params => { //填报考核列表接口-肖东
      return getRequest('app/lzKpiForm/kpiStatisticsList', params)
    },
    geoXiaobanList: params => { //林地列表查询接口-肖东
      return getRequest('app/geoXiaoban/geoXiaobanList', params)
    },
    //新接口

    NewMyKpiList: year => { //填报考核列表接口-肖东
      return getRequest('app/lzKpiForm/selfKpiStatistics/' + year, {})
    },
    newMyKpiDetail: (mode, year, gridObjid) => { //填报考核列表详情-肖东
      if (mode == 'org') {
        return getRequest('app/lzKpiForm/orgKpiStatistics/' + year, {}) //组织考核成绩统计分析详情查询接口-肖东
      } else if (mode == 'region') {
        return getRequest('app/lzKpiForm/regionKpiStatistics/' + year, {}) //政区考核成绩统计分析详情查询接口-肖东
      } else {
        return getRequest('app/lzKpiForm/gridKpiStatistics/' + year + '/' + gridObjid, {}) //责任区考核成绩统计分析详情查询接口-肖东
      }
    },
    newMyKpiOneList: params => { //林长信息-考核-考核结果-考核项详细数据查询接口-肖东 getKpiDetail
      return getRequest('app/lzKpiForm/kpi1AmountList', params)
    },
    newMyKpiTwoList: params => { //林长信息-考核-考核结果-考核项下考核内容详细数据查询接口-肖东
      return getRequest('app/lzKpiForm/kpi2AmountList', params)
    },
    //林长-数据

    lzKpiFormScoreList: (pageNum, pageSize, params) => { //林长信息-考核-考核结果-考核项下考核内容详细数据查询接口-肖东
      return getRequest('app/lzKpiForm/lzKpiFormScoreList/' + pageNum + '/' + pageSize, params)
    },
    getKpiFormScoreList: (pageNum, pageSize, type, params) => { //林长-数据-组织考核排名接口-肖东
      if (type == 'org') {
        return getRequest('app/lzKpiForm/orgKpiFormScoreList/' + pageNum + '/' + pageSize, params)
      } else if (type == 'region') {
        return getRequest('app/lzKpiForm/regionKpiFormScoreList/' + pageNum + '/' + pageSize, params)
      } else {
        return getRequest('app/lzKpiForm/gridKpiFormScoreList/' + pageNum + '/' + pageSize, params)
      }
    },

    // getRegionKpiFormScoreList: (pageNum,pageSize) => {  //林长-数据-组织考核-政区考核排名接口-肖东
    //   return getRequest('app/lzKpiForm/regionKpiFormScoreList/'+pageNum+'/'+pageSize,{})
    // },
    // getOrgKpiFormScoreList: (pageNum,pageSize) => {  //林长-数据-组织考核-组织机构考核排名接口-肖东
    //   return getRequest('app/lzKpiForm/orgKpiFormScoreList/'+pageNum+'/'+pageSize,{})
    // },
    // getGridKpiFormScoreList: (pageNum,pageSize) => {  //林长-数据-组织考核-责任区考核排名接口-肖东
    //   return getRequest('app/lzKpiForm/gridKpiFormScoreList/'+pageNum+'/'+pageSize,{})
    // },

  },
};
//搜索模块
const search = {
  searchArea: (num, page, params) => { //搜索政区接口-谢明
    return getRequest('app/resourceSelect/resourceZqList/' + num + '/' + page, params)
  },
  searchBillboard: (num, page, params) => { //搜索公示牌接口-肖东
    return getRequest('app/resourceSelect/resourceBoardList/' + num + '/' + page, params)
  },
  // resourceGridList: (num, page, params) => { //搜索责任区接口-肖东
  //   return getRequest('app/resourceSelect/resourceGridList/' + num + '/' + page, params)
  // },
  resourceZqAndZrqTree: params => { //搜索政区与重点责任区接口-肖东
    return getRequest('app/resourceSelect/resourceZqAndZrqTree', params)
  },
  resourceDiscoverList: (num, page, params) => { //搜索发现接口-肖东
    return getRequest('app/resourceSelect/resourceDiscoverList/' + num + '/' + page, params)
  },
  resourceXiaobanList: (num, page, params) => { //搜索林地接口-肖东
    return getRequest('app/resourceSelect/resourceXiaobanList/' + num + '/' + page, params)
  },

  resourceZaolinList: (num, page, params) => { //搜索营造林地接口-肖东
    return getRequest('app/resourceSelect/resourceZaolinList/' + num + '/' + page, params)
  },
  resourceMonitorList: (num, page, params) => { //搜索监测点接口-肖东
    return getRequest('app/resourceSelect/resourceMonitorList/' + num + '/' + page, params)
  },
  // /api/app/ancientTreeInfo/getLztAncientTreeList/{pageNum}/{pageSize}

  resourceGushuList: (num, page, params) => { //APP端-林长通(责任区)-古树名木管理列表查询接口-肖东
    return getRequest('app/ancientTreeInfo/getLztAncientTreeList/' + num + '/' + page, params)
  },
  resourceUserList: (num, page, params) => { //搜索人员接口-肖东
    return getRequest('app/resourceSelect/resourceUserList/' + num + '/' + page, params)
  },
  resourceTaskList: (num, page, params) => { //搜索任务接口-肖东
    return getRequest('app/resourceSelect/resourceTaskList/' + num + '/' + page, params)
  },
  resourceShidiList: (num, page, params) => { //搜索湿地接口-肖东
    return getRequest('app/resourceSelect/resourceShidiList/' + num + '/' + page, params)
  },
  resourceBaohudiList: (num, page, params) => { //搜索自然保护地接口-肖东
    return getRequest('app/resourceSelect/resourceBaohudiList/' + num + '/' + page, params)
  },
  resourceHongxianList: (num, page, params) => { //搜索自然保护地接口-肖东
    return getRequest('app/resourceSelect/resourceHongxianList/' + num + '/' + page, params)
  },
  resourceEvaluateList: (num, page, params, type) => { //搜索评价接口-肖东
    return type == 'linForest' ?
      getRequest('app/resourceSelect/resourceXbEvaluateList/' + num + '/' + page, params) //搜索林地评价接口-肖东
      :
      getRequest('app/resourceSelect/resourceTreeEvaluateList/' + num + '/' + page, params) //搜索古树评价接口-肖东

  },
  resourceCommentList: (num, page, params, type) => { //搜索评价接口-肖东
    return type == 'linForest' ?
      getRequest('app/resourceSelect/resourceXbCommentList/' + num + '/' + page, params) //搜索林地评论接口-肖东
      :
      getRequest('app/resourceSelect/resourceTreeCommentList/' + num + '/' + page, params) //搜索古树评论接口-肖东

  },
};

//字典相关接口
const dict = {
  dictList: params => { //责任区信息查询接口-肖东
    return getRequest('pub/dict/list', params)
  },

};

//古树名木系统---古树相关接口  另外一个系统
const slbkOldTree = {
  //新增古树编辑古树
  updateOldTree: (id, params) => {
    return id == '' ?
      postRequest('app/ancientTreeInfo/insert', params, "oldTree") //APP端-百科-新增古树名木信息接口-肖东
      :
      postRequest('app/ancientTreeInfo/update', params, "oldTree") //APP端-百科-更新古树名木信息接口-肖东
  },
  //删除古树
  delete: (id) => { //APP端-百科-删除古树-肖东
    return postRequest('app/ancientTreeInfo/delete/' + id, {}, "oldTree")
  },
  //获取古树名木系统 用户信息-肖东 
  getLogin: (params) => {//森林百科-->古树名木
    return getRequest('app/externalUser/getExternalUser', params, "oldTree")
  },
  getLztToGsLogin: (params) => {//林长通-->古树名木
    return getRequest('app/ancientTree/getExternalUser', params)
  },

  mapGuShuList: (pageNum, pageSize, params) => { //APP端-百科-古树名木-古树定位(距离)列表接口-肖东
    return getRequest('app/ancientTreeInfo/treeLocationList/' + pageNum + '/' + pageSize, params, "oldTree")
  },
  mapGuShuNewsDetails: id => { //公共-古树动态详情-谢明
    return getRequest('pub/tree/treeNewsDetail/' + id, {}, "oldTree")
  },
  mapGuShuNewsCount: params => { //公共-古树动态条数-谢明
    return getRequest('pub/tree/treeHasNews', params, "oldTree")
  },
  //古树名木系统==>我的管理==>古树列表
  treeList: (pageNum, pageSize, params) => { //古树列表
    return getRequest('app/ancientTreeInfo/getAncientTreeList/' + pageNum + '/' + pageSize, params, "oldTree")
  },
  //古树名木系统==>我的管理==>启用禁用古树
  state: (enable, treeId) => { //APP端-百科-启用禁用古树名木接口-肖东
    return postRequest('app/ancientTreeInfo/setEnable/' + treeId + '/' + enable, {}, "oldTree")
  },
  //古树地图详情
  mapGuShuDetail: (mode, id) => {
    return getRequest('pub/tree/guShuDetail/' + id, {}, "oldTree") //objid-古树基本信息查询接口-谢明

  },
  //古树图片查询
  mapGuShuImg: params => { //treeId-古树图片查询接口-谢明
    return getRequest('pub/tree/guShuImg', params, "oldTree")
  },
  //古树图片新增
  addGuShuImg: params => { //treeId-古树图片查询接口-谢明
    return postRequest('pub/tree/guShuImg', params, "oldTree")
  },
  //古树评论查询
  guShuComment: (pageNum, pageSize, id, appType) => { //treeId-古树名木评论接口-肖东
    return getRequest('app/treeComment/getCommentList/' + pageNum + '/' + pageSize + '/' + id, {}, appType)
  },
  //新增古树评论
  addGuShuComment: (params, type) => { //treeId-新增古树名木评论接口-肖东
    return postRequest('app/treeComment/insert', params, type)
  },
  //古树chartData的监控数据
  reportData: params => {
    return getRequest('ancientPublic/report/data', params, "oldTree")
  },
  //获取评级列表标签
  treeEvaluateList: (params, type) => { //获取评价标签列表接口-肖东
    return getRequest('app/treeComment/getEvaluateTypeList', params, type)
  },
  //获取政区 省市县乡村接口
  getTreeZqCode: params => {
    return getRequest('app/geo/geoTreeList', params, "oldTree") //政区 省市县乡村接口-肖东
  },
  //获取纲 门 目 科 属 接口
  getTreeClassify: params => {
    return getRequest('app/ancientTreeInfo/pediaClassifyList', params, "oldTree") //获取纲门目科属接口-接口
  },
  //古树详情
  getTreeDetail: id => { //古树详情
    return getRequest('app/ancientTreeInfo/ancientTreeDetails/' + id, {}, "oldTree")
  },
  //修复记录
  //古树修复记录详情
  getTreeRepairDetail: (pageNum, pageSize, id) => { //古树详情
    return getRequest('app/repairRecord/getRepairRecordList/' + pageNum + '/' + pageSize + '/' + id, {}, "oldTree")
  },
  //古树修复记录新增/更新
  updateTreeRepair: (type, params) => { //古树详情
    return type === '' ?
      postRequest('app/repairRecord/insert', params, "oldTree") //新增古树名木修复记录接口-肖东
      :
      postRequest('app/repairRecord/update', params, "oldTree") //更新古树名木修复记录接口-肖东
  },
  //古树修复记录删除
  repairDelete: (id) => { //APP端-百科-删除古树修复记录-肖东
    return postRequest('app/repairRecord/delete/' + id, {}, "oldTree")
  },
  //统计分析
  getResourceInfo: code => { //APP端-百科-统计分析-古树等级分布及树种分布查询接口-肖东
    return getRequest('app/ancientTreeInfo/getResourceInfo/' + code, {}, "oldTree")
  },
  getAncientTreeNum: code => { //APP端-百科-统计分析-古树名木株数统计接口-肖东
    return getRequest('app/ancientTreeInfo/getAncientTreeNum/' + code, {}, "oldTree")
  },
  getAppRegionTreeNum: (pageNum, pageSize, code) => { //APP端-百科-统计分析-位置分布查询接口-肖东
    return getRequest('app/ancientTreeInfo/getAppRegionTreeNum/' + pageNum + '/' + pageSize + '/' + code, {}, "oldTree")
  },
  //生态监测
  getVideoSurveillance: (device, isHTTPS, params, appType) => { //生态检测获取视频地址接口-张涛山
    return appType === 'oldTree' ?
      postRequest('lzt/tree/getVideoSurveillance/' + device + '/' + isHTTPS, params, "oldTree") // 森林百科调用
      :
      postRequestParams('app/ancientTree/getVideoSurveillance/' + device + '/' + isHTTPS, params,)//林长通调用

  },

  getTreechart: (device, key, appType) => { //生态检测指标曲线图接口-张涛山  
    return appType === 'oldTree' ?
      postRequest('lzt/tree/chart/' + device + '/' + key, {}, "oldTree") // 森林百科调用
      :
      postRequest('app/ancientTree/chart/' + device + '/' + key, {})//林长通调用

  },
  //字典   获取古树等级字典
  getDictItemList: (params) => { //字典项列表-陶创
    return getRequest('app/dict/dictItemList', params, "oldTree")
  }
};


//扫取二维码 获取责任区内容
const pubZrq = {
  dutyMsg: params => { //责任区信息查询接口-肖东
    return getRequest('pub/resource/lzUserAreaDetails', params)
  },
 zqMsg: params => { //责任区信息查询接口-肖东
    return getRequest('pub/resource/lzUserRegionDetails', params)
  },
 
  getAreaBoard: params => { //责任区电子公示牌查询接口-肖东
    return getRequest('pub/resource/getAreaBoard', params)

  },
  getZqAreaBoard: params => { //政区电子公示牌查询接口-肖东
    return getRequest('pub/resource/getZqAreaBoard', params)

  },
  myGridStatistics: params => { //责任区信息查询接口-肖东
    return getRequest('pub/resource/myGridStatistics', params)

  },
  gridStatisticalChart: params => { //责任区信息查询接口-肖东
    return getRequest('pub/resource/gridStatisticalChart', params)

  },
  nextRegionList: params => { //责任区下级政区查询接口-肖东
    return getRequest('pub/resource/nextRegionList', params)
  },
  getGridArchives: params => { //根据责任区|政区获取文本信息接口-陈国贵
    return getRequest('pub/resource/gridArchives', params)
  },
  getPlayauth: (videoId) => {
    //获取音视频播放凭证信息
    return fileGet("base/oss/vod/playauth/" + videoId, {});
  },

  //无token政区信息
  gridAreaDetails: params => { //政区信息查询接口-陈国贵
    return getRequest('pub/resource/regionAreaDetails', params)
  },
  gridMergeForestList: (pageNum, pageSize, params) => { //责任区|政区巡林记录列表-合并-分页-陈国贵
    return getRequest('pub/resource/gridMergeForestList/' + pageNum + '/' + pageSize, params)
  },
  //群众建议列表-王愿
  suggestList: (params) => {  
    return getRequest('pub/info/crowd/suggest/list', params)
  },
  //群众建议保存-王愿
  suggestSave: (params) => {  
    return postRequest('pub/info/crowd/suggest/save', params)
  },

};

//新增巡林数据中心接口
const xunLData = {
  getXunLStatistics: (params) => { //数据-巡林统计查询接口-肖东
    return getRequest("app/protect/xunLStatistics", params);
  },

  getxunLTrend: (type) => { //数据-巡林趋势图数据查询接口-肖东
    return getRequest("app/protect/xunLTrend/" + type, {});
  },

  getXunLRank: (pageNum, pageSize, type, mode) => {
    if (mode == "person") {
      return getRequest('app/protect/xunLPersonageRank/' + pageNum + '/' + pageSize + '/' + type, {}) //数据-排行榜-个人榜排名查询接口-肖东
    } else if (mode == "administrative") {
      return getRequest('app/protect/xunLRegionRank/' + pageNum + '/' + pageSize + '/' + type, {}) //数据-排行榜-政区榜排名查询接口-肖东
    } else {
      return getRequest('app/protect/xunLGridRank/' + pageNum + '/' + pageSize + '/' + type, {}); // 数据-排行榜-责任区榜排名查询接口-肖东
    }

  },
  xunLRecordList: (pageNum, pageSize) => { //数据-巡林记录查询接口-肖东
    return getRequest("app/protect/xunLRecordList/" + pageNum + '/' + pageSize, {});
  },

  getXunLDetails: (id, params) => { //数据-护林详情接口-肖东
    return getRequest("app/protect/details/" + id, params);
  },

};



//将相关接口模块曝露出去
export default {
  Mapapi,
  User,
  News,
  inform,
  Review,
  Laws,
  worker,
  Scan,
  universal,
  linLong,
  search,
  hulin,
  dict,
  slbkOldTree,
  pubZrq,
  xunLData
}